import { API } from "../api";
const BASE_URL = "/cooperatives/settings/event";

export const eventSettingsExtendedApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getEventSettings: builder.query({
      query: () => `${BASE_URL}?guard=staff`,
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "EventSettings", id: "CURRENT" }],
    }),
    updateEventSettings: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/update?guard=staff`,
        method: "POST",
        body: body,
      }),
      transformResponse: (responseData) => responseData, // Return full response to check status
      invalidatesTags: [{ type: "EventSettings", id: "CURRENT" }],
    }),
  }),
});

export const {
  useGetEventSettingsQuery,
  useUpdateEventSettingsMutation,
} = eventSettingsExtendedApi;
